module.exports = __webpack_public_path__ + "img/meals.47c779d8.jpg";